<template>
  <div class="wpcm-amount-box">
    <div class="wpcm-donation-amt-fields">
      <!-- Currency Select -->
      <div class="el-custom-select" v-if="show_currency_dropdown && props.currencies">
        <el-select class="w-100" v-model="store.currency" @change="store.currency = $event">
          <el-option v-for="(curr, key) in props.currencies" :value="key" :key="key" :label="curr">{{ curr }}</el-option>
        </el-select>
      </div>

      <!-- Custom Select -->
      <div class="el-custom-select" v-if="show_custom_dropdown">
        <el-select class="w-100" v-model="store.extras.donation_custom_dropdown"
          @change="setValue('donation_custom_dropdown', $event)" placeholder="Select Any Honoree ">
          <el-option v-for="(curr, key) in donation_custom_dropdown" :value="key" :key="key" :label="curr">{{ curr }}</el-option>
        </el-select>
      </div>

      <!-- Causes Select -->
      <div class="el-custom-select" v-if="show_causes_dropdown">
        <el-select class="w-100" v-model="store.selectedCause" @change="setValue('selectedCause', $event)" placeholder="Select Any Cause">
          <el-option v-for="(cause, key) in causes_list" :key="key" :value="key" :label="cause">{{ cause }}</el-option>
        </el-select>
      </div>

      <slot name="donation_dropdowns"></slot>

      <!-- Amount Title -->
      <div v-if="strings && props.show_amounts && props.amounts">
        <strong class="wpcm-cstm-amt-txt">{{ strings.how_much }}</strong>
      </div>

      <!-- Predefined Amounts -->
      <ul class="wpcm-pre-dfind-amt" v-if="props.show_amounts && props.amounts && !store.recurring">
        <li v-for="amnt in props.amounts" :key="amnt" @click.prevent="store.amount = convert(amnt)">
          <a href="#" :class="['wpdonation-button', store.amount == convert(amnt) && 'active']">{{ getSymbol() }}{{ convert(amnt) }}</a>
        </li>
      </ul>

      <!-- Recurring Amounts -->
      <ul class="wpcm-pre-dfind-amt" v-if="props.show_amounts && props.amounts_recurring && store.recurring">
        <li v-for="amnt in props.amounts_recurring" :key="amnt" @click.prevent="store.amount = convert(amnt)">
          <a href="#" :class="['wpdonation-button', store.amount == convert(amnt) && 'active']">{{ getSymbol() }}{{ convert(amnt) }}</a>
        </li>
      </ul>

      <!-- Reward Images for One-Time Donations -->
      <div class="wpcm-reward-images" v-if="show_reward_images && !store.recurring && matchingRewardIndex !== -1">
        <div class="reward-preview">
          <img :src="props.reward_images[matchingRewardIndex]" :alt="'Reward for ' + store.amount + ' donation'" class="reward-image">
          <p class="reward-description">{{props.reward_images_text}}</p>
        </div>
      </div>

      <!-- Reward Images for Recurring Donations -->
      <div class="wpcm-reward-images" v-if="show_reward_images_recurring && store.recurring && matchingRecurringRewardIndex !== -1">
        <div class="reward-preview">
          <img :src="props.recurring_images[matchingRecurringRewardIndex]" :alt="'Recurring Reward for ' + store.amount + ' donation'" class="reward-image">
          <p class="reward-description">{{ props.reward_images_text }}</p>
        </div>
      </div>

      <!-- Display Amount -->
      <div v-if="!props.show_amounts && props.display_amount">{{ getSymbol() }}{{ props.display_amount }}</div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, computed } from 'vue';
import { useDonationFormsStore } from '../store';

const store = useDonationFormsStore();
const props = defineProps({
  donation_custom_dropdown: Array,
  currencies: Object,
  amounts: Array,
  strings: Object,
  show_currency_dropdown: Boolean,
  show_custom_dropdown: Boolean,
  show_amounts: Boolean,
  custom_amount: Number,
  show_recurring: Boolean,
  symbols: Object,
  symbol: String,
  display_amount: Number,
  amounts_recurring: Array,
  show_causes_dropdown: Boolean,
  causes_list: Array,
  show_reward_images: Boolean,
  reward_amounts: Array,
  reward_images: Array,
  show_reward_images_recurring: Boolean,
  recurring_rewards: Array,
  recurring_images: Array,
  reward_images_text: String
});

const lifeline_donation = globalThis.lifeline_donation;
const _ = globalThis._;

const setValue = (key: string, val: string | number) => {
  store[key] = val;
};

const getSymbol = () => {
  return props.symbols[store.currency] != undefined ? props.symbols[store.currency] : props.symbol;
};

const convert = (amt: number) => {
  const { exchange_rates } = lifeline_donation;
  const syb = store.currency;
  if (_.get(exchange_rates, syb)) {
    return (_.get(exchange_rates, syb) * amt).toFixed(2);
  }
  return amt;
};

onMounted(() => {
  if (props.show_amounts && _.size(props.amounts)) {
    setValue('amount', props.amounts[0]);
  }
  if (props.show_currency_dropdown && _.size(props.currencies)) {
    setValue('currency', _.keys(props.currencies)[0]);
  }
  if (props.display_amount) {
    store.amount = props.display_amount;
  }
});

const matchingRewardIndex = computed(() => {
  return props.reward_amounts.findIndex(amount => convert(amount) == store.amount);
});

const matchingRecurringRewardIndex = computed(() => {
  return props.recurring_rewards.findIndex(amount => convert(amount) == store.amount);
});
</script>

<style>
.wpcm-reward-images {
  margin-top: 20px;
  text-align: center;
}

.reward-preview {
  padding: 15px;
  border: 1px solid #eee;
  border-radius: 8px;
  margin-top: 10px;
}

.reward-image {
  max-width: 200px;
  height: auto;
  margin-bottom: 10px;
}

.reward-description {
  font-size: 14px;
  color: #666;
  margin: 5px 0;
}
</style>
